import profile_pic from "../assets/images/profile_1.jpg";
import { IoLogoLinkedin } from "react-icons/io5";
import { IoLogoGithub } from "react-icons/io5";
import { IoMail } from "react-icons/io5";
import TrackedLink from "./TrackedLink";

function Intro({ bg }) {

  return (
    <div className="section-container" style={{ backgroundColor: bg }}>
      <div className="content-container xl:flex-row xl:justify-between">
        <div className="">
          <div className="mb-10">
            <img className="rounded-full w-32 md:w-56 xl:w-96" src={profile_pic} alt="Profile" title="Profile" />
          </div>
        </div>
        <div className="">
          <div className="my-4">
            <h1>Aaron Worku</h1>
          </div>
          <div className="my-8">
            <h2>Product Leader</h2>
          </div>
          <div>
            <p className="my-6 font-medium">Life-long learner passionate about creating great digital experiences</p>
          </div>
          <div className="flex flex-row my-3">
            <TrackedLink href="https://www.linkedin.com/in/aaron-worku/" kingdom="linkedin">
              <div className="link-icon-container mr-4">
                <IoLogoLinkedin size={24} />
              </div>
            </TrackedLink>
            <TrackedLink
              href="https://github.com/aaronworku?tab=overview&from=2025-01-01&to=2025-12-31"
              kingdom="github"
            >
              <div className="link-icon-container mr-4">
                <IoLogoGithub size={30} />
              </div>
            </TrackedLink>
            <TrackedLink href="mailto:aaron.d.work.u@gmail.com" kingdom="mail_to">
              <div className="link-icon-container">
                <IoMail size={30} />
              </div>
            </TrackedLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Intro;
